export const authApi = (client) => ({
    login: (body) => client.post('/api/v1/auth/login', body).then((r) => r.data),
    /**
     * Email-first login. Backend resolves the workspace from the email:
     * if it matches one workspace the user gets tokens; if it matches
     * multiple, you get back a picker list and re-call `login()` with
     * the chosen slug; if it matches none, 401.
     */
    loginByEmail: (body) => client.post('/api/v1/auth/login-by-email', body).then((r) => r.data),
    /**
     * Sign in with a Google ID token — backend verifies it and resolves
     * the workspace the same way `loginByEmail` does. `org_slug` is the
     * second step of the picker flow: resubmit the same `id_token` with
     * the workspace the user picked.
     */
    googleAuth: (body) => client.post('/api/v1/auth/google', body).then((r) => r.data),
    superAdminLogin: (body) => client.post('/api/v1/auth/super-admin-login', body).then((r) => r.data),
    switchOrg: (body) => client.post('/api/v1/auth/switch-org', body).then((r) => r.data),
    requestInvite: (body) => client.post('/api/v1/auth/request-invite', body).then((r) => r.data),
    registerOrg: (body) => client.post('/api/v1/auth/register-org', body).then((r) => r.data),
    refresh: (body) => client.post('/api/v1/auth/refresh', body).then((r) => r.data),
    logout: (body) => client.post('/api/v1/auth/logout', body).then((r) => r.data),
    me: () => client.get('/api/v1/auth/me').then((r) => r.data),
    /**
     * Server clock. Frontend uses this to compute an offset against the
     * browser's clock so countdowns and "is it time" checks aren't off
     * if the device clock is wrong or has been deliberately set back.
     */
    serverTime: () => client.get('/api/v1/auth/time').then((r) => r.data),
    /**
     * Public lookup so the signup form can prefill the email field once the
     * user pastes a valid invite code. Returns `{ valid: false }` on misses.
     */
    lookupInviteCode: (code) => client
        .get(`/api/v1/auth/invite-code/${encodeURIComponent(code)}`)
        .then((r) => r.data),
    forgotPassword: (body) => client.post('/api/v1/auth/forgot-password', body).then((r) => r.data),
    validateResetToken: (token, org_slug) => client
        .get(`/api/v1/auth/reset-password/validate/${encodeURIComponent(token)}`, { params: { org_slug } })
        .then((r) => r.data),
    resetPassword: (body) => client.post('/api/v1/auth/reset-password', body).then((r) => r.data),
    changePassword: (body) => client.post('/api/v1/me/change-password', body).then((r) => r.data),
});
//# sourceMappingURL=auth.js.map